"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadForm = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
/* Imported CSS */
require("./UploadForm.scss");
/* Blast Imports */
var FileSelect_1 = __importDefault(require("./FileSelect"));
var FilesizeLimitIndicator_1 = require("./FilesizeLimitIndicator");
var PackageDetailsForm_1 = __importDefault(require("./PackageDetailsForm"));
var selectors_1 = require("../../state/selectors");
var models_1 = require("@app/_state/models");
var actions_1 = require("@app/features/package-details/state/actions");
var PackageFiles_1 = require("@app/features/package-files/components/PackageFiles");
var actions_2 = require("@app/features/package-files/state/actions");
var actions_3 = require("@app/features/transfers/state/actions");
var actions_4 = require("@app/features/ui/state/actions");
var actions_5 = require("@app/features/users/state/actions");
var UsersApi = __importStar(require("@app/services/api/users"));
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var utils_2 = require("@app/shared/utils");
var initialState = {
    shouldResetPackageDetails: false
};
/**
 * Blast's Upload Package Form component, displays all the fields available to submit the upload of a new package
 */
var UploadForm = /** @class */ (function (_super) {
    __extends(UploadForm, _super);
    function UploadForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleCancelSubmit = function (reset) {
            _this.props.onClearStagedFiles();
            new matomo_1.MatomoTracker().trackEvent('Upload Form', 'Reset Form');
            if (_this.props.packageId && reset) {
                _this.props.onForwardReset();
            }
        };
        _this.handleCollapse = function (file) {
            _this.props.onCollapse(file.path);
        };
        _this.handleExpand = function (file) {
            var packageId = _this.props.packageId;
            if (packageId) {
                _this.props.onExpand(packageId, file, true);
            }
        };
        _this.handleFileSelect = function (files) {
            if (files.length > 0) {
                _this.props.onAddToast(actions_4.ToastType.FILE_SELECT_ADDED_FILES, 'File(s) Added');
            }
            _this.props.onSelectFiles(files);
        };
        _this.handleLoadMoreRemoteFiles = function (sourceId, offset, path) {
            _this.props.onGetRemoteFiles(sourceId, offset, path);
        };
        _this.handleOpenRemoteSource = function (sourceId, path) {
            if (sourceId !== _this.props.selectedRemoteSource) {
                _this.props.onClearStagedFiles();
            }
            _this.props.onGetRemoteFiles(sourceId, 0, path);
        };
        _this.handleRemoveFile = function (file) {
            _this.props.onRemoveFile(file);
        };
        _this.handleSendPackage = function (to, subject, message, packageId, packageExpirationDays, notifyOnDownload, notifiableOnDownload, notifyOnUpload, notifiableOnUpload, encryptPackage, enableForwarding, isWorkgroupPackage) {
            _this.setState({ shouldResetPackageDetails: false });
            var convertedRecipients = [];
            for (var _i = 0, to_1 = to; _i < to_1.length; _i++) {
                var i = to_1[_i];
                var recipientName = isWorkgroupPackage ? (i.startsWith('*') ? i.substring(1) : i) : i;
                convertedRecipients.push({
                    name: recipientName,
                    recipient_type: isWorkgroupPackage ? 'workgroup' : 'user' // TODO-V5: determine other types?
                });
            }
            var prioritizedRecipients = new Set(constants_1.PRIORITIZED_EMAILS);
            var sortedRecipients = __spreadArray(__spreadArray([], convertedRecipients.filter(function (r) { return prioritizedRecipients.has(utils_1.normalize(r.name)); })), convertedRecipients.filter(function (r) { return !prioritizedRecipients.has(utils_1.normalize(r.name)); }));
            var convertedNotifyDownload = [];
            for (var _a = 0, notifiableOnDownload_1 = notifiableOnDownload; _a < notifiableOnDownload_1.length; _a++) {
                var i = notifiableOnDownload_1[_a];
                convertedNotifyDownload.push({
                    name: i
                });
            }
            var convertedNotifyUpload = [];
            for (var _b = 0, notifiableOnUpload_1 = notifiableOnUpload; _b < notifiableOnUpload_1.length; _b++) {
                var i = notifiableOnUpload_1[_b];
                convertedNotifyUpload.push({
                    name: i
                });
            }
            var packageDetails = {
                ear_enabled: encryptPackage,
                isSenderPluginless: (!_this.props.pluginEnabled && !_this.props.httpGatewayStatus),
                isWorkgroupPackage: isWorkgroupPackage,
                metadata: [
                    { name: 'ForwardDisabled', value: enableForwarding ? 'no' : 'yes' },
                    { name: 'PasswordProtected', value: encryptPackage ? 'yes' : 'no' }
                ],
                note: message,
                notified_on_download: convertedNotifyDownload,
                notified_on_upload: convertedNotifyUpload,
                notify_on_download: notifyOnDownload,
                notify_on_upload: notifyOnUpload || packageId !== '',
                packageExpirationDays: packageExpirationDays,
                packageId: packageId,
                recipients: sortedRecipients,
                remoteSourceId: _this.props.selectedRemoteSource,
                title: utils_2.trimSpacesAndPeriods(subject)
            };
            if (packageDetails.packageId) {
                // Forward existing package
                _this.props.onForwardPackage(packageDetails);
            }
            else if (_this.props.selectedRemoteSource > -1) {
                // Create package with files from Remote Server
                _this.props.onRemoteTransfer({
                    files: _this.props.files,
                    packageDetails: packageDetails,
                    shareId: _this.props.selectedRemoteSource
                });
            }
            else {
                if (_this.props.pluginEnabled) {
                    // Upload using Aspera Connect
                    _this.props.onConnectUpload({
                        files: _this.props.files,
                        packageDetails: packageDetails
                    });
                }
                else {
                    if (_this.props.httpGatewayStatus) {
                        // Upload via HTTP Gateway
                        log_1.default.debug('SUBMITTING PACKAGE VIA HTTP GATEWAY');
                        _this.props.onHttpGatewayUpload({
                            files: _this.props.files,
                            packageDetails: packageDetails
                        });
                    }
                    else {
                        // Upload using http
                        log_1.default.debug('SUBMITTING PACKAGE VIA PLUGINLESS');
                        _this.props.onHttpUpload({
                            files: _this.props.files.map(function (f) { return f.fileData; }),
                            packageDetails: packageDetails
                        });
                    }
                }
            }
        };
        _this.handleValidateUser = function (email, restrictSelection) { return __awaiter(_this, void 0, void 0, function () {
            var canSendToExternal, isEmailInternal, isUserInternal, exists, primaryEmail, workgroup, response, _a, users, user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        canSendToExternal = this.props.isUserInternal || !restrictSelection;
                        isEmailInternal = utils_2.isInternalEmail(email);
                        isUserInternal = false;
                        exists = false;
                        if (!(isEmailInternal || canSendToExternal)) return [3 /*break*/, 5];
                        workgroup = this.props.workgroupsList.find(function (u) { return u.email.toLowerCase() === email.toLowerCase(); });
                        if (!workgroup) return [3 /*break*/, 1];
                        isUserInternal = workgroup.isInternal;
                        exists = true;
                        return [3 /*break*/, 4];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, UsersApi.getUserMinimal(email)];
                    case 2:
                        response = _b.sent();
                        isUserInternal = response.isInternal;
                        primaryEmail = response.primaryEmail;
                        exists = true;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        log_1.default.debug(email + " is internal email: " + utils_2.isInternalEmail(email));
                        if (isEmailInternal && restrictSelection) {
                            throw new Error("Unable to invite " + email + " because they are a Hasbro user");
                        }
                        else {
                            exists = false;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, UsersApi.getUsersInteractions()];
                    case 6:
                        users = _b.sent();
                        user = __spreadArray(__spreadArray([], this.props.workgroupsList), users).find(function (u) { return u.email.toLowerCase() === email.toLowerCase(); });
                        if (user) {
                            isUserInternal = user.isInternal;
                            exists = true;
                        }
                        else {
                            throw new Error("User does not have permissions to send packages to " + email);
                        }
                        _b.label = 7;
                    case 7: return [2 /*return*/, {
                            isInternal: isUserInternal,
                            primaryEmail: primaryEmail,
                            exists: exists
                        }];
                }
            });
        }); };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    UploadForm.prototype.componentDidMount = function () {
        var packageId = this.props.packageId;
        if (packageId) {
            this.props.onGetPackage(packageId);
            this.props.onGetPackageFiles(packageId);
        }
    };
    UploadForm.prototype.componentDidUpdate = function (prevProps) {
        if ((this.props.transferSuccessMessage && (this.props.transferSuccessMessage !== prevProps.transferSuccessMessage)) ||
            (this.props.packageDetails && prevProps.packageDetails === undefined && (this.props.packageDetails.pkgState === models_1.PackageState.DELETED || this.props.packageDetails.pkgState === models_1.PackageState.EXPIRED))) {
            this.setState({ shouldResetPackageDetails: true });
        }
    };
    /* Component Methods - end */
    UploadForm.prototype.render = function () {
        var _a;
        // Component properties
        var props = this.props;
        if (!props.isUserInternal && props.packageDetails) {
            // If the user isn't an internal user, and they're attempting to forward any existing package,
            // Confirm they are the original sender otherwise redirect to a normal upload form
            if (props.loggedInUser && props.packageDetails.sender.userEmail !== ((_a = props.loggedInUser) === null || _a === void 0 ? void 0 : _a.userEmail)) {
                return react_1.default.createElement(react_router_1.Redirect, { to: "/dash/packages/upload" });
            }
        }
        /* Upload Form constants */
        var maxTotalSizeInBytes = utils_2.megabytesToBytes(props.maxTotalSize);
        var packageFilesTotalSize = (props.packageDetails) ? props.packageDetails.totalBytes : 0;
        var exceededPackageSizeLimit = (packageFilesTotalSize > maxTotalSizeInBytes) && !props.pluginEnabled && !props.packageId;
        var exceededStagedSizeLimit = (props.stagedFilesTotalSize > maxTotalSizeInBytes) && !props.pluginEnabled && props.selectedRemoteSource === -1;
        var exceededSizeLimit = (props.packageId && (props.packageFiles && props.packageFiles.length !== 0)) ? exceededPackageSizeLimit : exceededStagedSizeLimit;
        var noPackageFilesSelected = (props.packageFiles && props.packageFiles.length === 0);
        var noStagedFilesSelected = (props.files && props.files.length === 0);
        var noFilesSelected = (props.packageId) ? noPackageFilesSelected : noStagedFilesSelected;
        var currentUserIsSender = props.packageId && props.packageDetails && props.loggedInUser && props.packageDetails.sender.userEmail === props.loggedInUser.userEmail;
        // Disable submit when 1) no files selected or 2) total size of files exceeds limit or 3) upload is in progress 4) package can't be forwarded by anyone but the original sender
        var packageDetailsDisabled = noFilesSelected || exceededSizeLimit || props.isUploading ||
            !!(props.packageDetails && props.packageDetails.disableForwarding && !currentUserIsSender);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", { className: 'official-msg' },
                "Blast is for Official Hasbro Business Only",
                react_1.default.createElement("span", { className: "icon message-help-tooltip tooltip is-tooltip-bottom", "data-tooltip": "For more information, please reach out to ITSecurity@hasbro.com" },
                    react_1.default.createElement("i", { className: "fas fa-info-circle" }))),
            exceededSizeLimit &&
                react_1.default.createElement("article", { className: "message is-danger", "data-test": "size-limit-exceeded-error" },
                    react_1.default.createElement("div", { className: "message-body" },
                        "You are limited to uploading packages that are ",
                        filesize_1.default(utils_2.megabytesToBytes(this.props.maxTotalSize)),
                        " or less. To upload larger files, please toggle \"Enable Aspera\" at the top of the page and install the Aspera Connect plugin.")),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column upload-form" },
                    react_1.default.createElement("div", { className: "columns upload-form-sections" },
                        react_1.default.createElement("div", { className: "column is-half upload-form-section" },
                            react_1.default.createElement(PackageDetailsForm_1.default, { httpGatewayStatus: props.httpGatewayStatus, loggedInUserEmail: (props.loggedInUser) ? props.loggedInUser.userEmail : '', loggedInUserIsInternal: (props.loggedInUser) ? props.loggedInUser.isInternal : false, pluginEnabled: props.pluginEnabled, users: props.users, disabled: packageDetailsDisabled, shouldReset: this.state.shouldResetPackageDetails, packageDetails: props.packageId ? props.packageDetails : undefined, packageExpirationDays: props.packageExpirationDays, onQueryUsers: props.onQueryUsers, onSubmit: this.handleSendPackage, onCancel: this.handleCancelSubmit, onValidateUser: this.handleValidateUser, selectedRemoteSource: this.props.selectedRemoteSource }),
                            props.transferErrorMessage &&
                                react_1.default.createElement("p", { className: "help is-danger" }, props.transferErrorMessage)),
                        react_1.default.createElement("div", { className: "column is-half upload-form-section" }, props.packageId && (props.packageFiles) ?
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(PackageFiles_1.PackageFiles, { asperaEnabled: props.pluginEnabled, className: 'limited-view', downloadEnabled: false, downloadSizeLimitInMB: 0, files: props.packageFiles, fileStatus: false, httpGatewayStatus: props.httpGatewayStatus, encryptedPackage: false, onExpand: this.handleExpand, onCollapse: this.handleCollapse, onDownload: function () { }, onOpenDownload: function () { }, onRetry: function () { }, onStop: function () { }, packageSize: 0 }),
                                !props.pluginEnabled && !props.packageId &&
                                    react_1.default.createElement(FilesizeLimitIndicator_1.FilesizeLimitIndicator, { currentSize: packageFilesTotalSize, maxSize: props.maxTotalSize }),
                                (props.packageFiles.length === 0) && (!props.filesAreLoading) &&
                                    react_1.default.createElement("article", { className: "message is-danger extra-top-margin" },
                                        react_1.default.createElement("div", { className: "message-body" },
                                            react_1.default.createElement("p", { className: "help" },
                                                react_1.default.createElement("span", { className: "icon is-danger" },
                                                    react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" })),
                                                react_1.default.createElement("span", null, "Forwarding of an expired package is not possible."))))) :
                            react_1.default.createElement(FileSelect_1.default, { pluginEnabled: props.pluginEnabled, files: props.files, currentTotalSize: props.stagedFilesTotalSize, isLoadingRemoteFiles: props.isLoadingRemoteFiles, isUploading: props.isUploading, maxTotalSize: (props.pluginEnabled || props.selectedRemoteSource > -1) ? 0 : props.maxTotalSize, onSelect: this.handleFileSelect, onRemove: this.handleRemoveFile, onLoadMoreRemoteFiles: this.handleLoadMoreRemoteFiles, onOpenRemoteSource: this.handleOpenRemoteSource, remoteFiles: props.remoteFiles, remoteSourcesList: props.remoteSources })))))));
    };
    return UploadForm;
}(react_1.Component));
exports.UploadForm = UploadForm;
var mapStateToProps = function (store) {
    return {
        files: store.transfers.stagedFiles,
        filesAreLoading: store.packageFiles.isLoading,
        httpGatewayStatus: store.transfers.httpGatewayStatus,
        isLoadingRemoteFiles: store.transfers.isLoadingRemoteFiles,
        isUploading: store.transfers.isUploading,
        isUserInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false,
        loggedInUser: store.auth.userInfo ? store.auth.userInfo : undefined,
        packageDetails: store.packageDetails.packageDetails,
        packageExpirationDays: store.dash.blastPackageExpirationDays || 21,
        packageFiles: store.packageFiles.packageFiles,
        pluginEnabled: selectors_1.isAsperaEnabled(store),
        remoteFiles: store.transfers.remoteFiles,
        remoteSources: store.users.remoteSources,
        selectedRemoteSource: store.transfers.selectedRemoteSource,
        stagedFilesTotalSize: selectors_1.getTotalSizeOfStagedFiles(store),
        transferErrorMessage: store.transfers.transferErrorMessage,
        transferSuccessMessage: store.transfers.transferSuccessMessage,
        users: store.users.filteredUsers,
        workgroupsList: store.users.workgroupUsers
    };
};
var mapDispatchToProps = {
    onAddToast: actions_4.addToast,
    onClearStagedFiles: actions_3.clearStagedFiles,
    onCollapse: actions_2.collapseDirectory,
    onConnectUpload: actions_3.connectUpload,
    onExpand: actions_2.expandDirectory,
    onForwardPackage: actions_3.forwardPackage,
    onForwardReset: actions_3.pushToUploadPage,
    onGetPackage: actions_1.getPackage,
    onGetPackageFiles: actions_2.getPackageFiles,
    onGetRemoteFiles: actions_3.getRemoteFiles,
    onHttpGatewayUpload: actions_3.httpGatewayUpload,
    onHttpUpload: actions_3.httpUpload,
    onQueryUsers: actions_5.queryUsers,
    onRemoveFile: actions_3.removeFile,
    onRemoteTransfer: actions_3.remoteTransfer,
    onSelectFiles: actions_3.selectFiles
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UploadForm);
